import { render, staticRenderFns } from "./FinanceCategoryCreate.vue?vue&type=template&id=e4c18aba&scoped=true"
import script from "./FinanceCategoryCreate.vue?vue&type=script&lang=js"
export * from "./FinanceCategoryCreate.vue?vue&type=script&lang=js"
import style0 from "./FinanceCategoryCreate.vue?vue&type=style&index=0&id=e4c18aba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c18aba",
  null
  
)

export default component.exports